import { BehaviorSubject } from 'rxjs';

import { fetchWrapper, history } from '../_helpers';

const baseUrl = `/lockers`;

export const lockerService = {
    getAll,
    getAllForKiosk,
    getUtilization,
    getById,
    getLockerInventory,
    getLockerInventoryForTransfer,
    getLockerAreaForReservation,
    getLockerPricing,
    getVenues,
    create,
    update,
    delete: _delete,
    enableLocker,
    disableLocker,
    bypassOpen,
    changeAccessCode,
    reassignRental
};

function changeAccessCode(gui_admin, kiosk, newCode) {
    return fetchWrapper.post(`/lockers/admin-locker-action`,
        {
            lockerNumber: gui_admin,
            action: "changeaccesscode",
            venue: kiosk,
            accessCode: newCode
        }).then(x => {
            return x;
        }).catch(e => { throw 'System Error Changing Access Code'; });
}

function enableLocker(gui_admin,kiosk) {
    return fetchWrapper.post(`/lockers/admin-locker-action`,
        {
            lockerNumber: gui_admin,
            action: "bypassenable",
            venue: kiosk
        }).then(x => {
            return x;
        }).catch(e => { throw 'System Error Enabling Locker'; });
}

function bypassOpen(gui_admin, kiosk) {
    return fetchWrapper.post(`/lockers/admin-locker-action`,
        {
            lockerNumber: gui_admin,
            action: "bypassopen",
            venue: kiosk
        }).then(x => {
            return x;
        }).catch(e => { throw 'System Error Opening Locker'; });
}

function disableLocker(gui_admin, kiosk) {
    return fetchWrapper.post(`/lockers/admin-locker-action`,
        {
            lockerNumber: gui_admin,
            action: "bypassdisable",
            venue: kiosk
        }).then(x => {
            return x;
        }).catch(e => { throw 'System Error Disabling Locker'; });
}

function reassignRental(originalLocker, newLocker, venue) {
    return fetchWrapper.post(`/lockers/admin-locker-action`,
        {
            lockerNumber: originalLocker,
            action: "reassign",
            venue: venue,
            newLockerNumber: newLocker
        }).then(x => {
            return x;
        }).catch(e => { throw 'System Error Reassigning Locker'; });
}

function getLockerInventoryForTransfer(date, area,reservationId) {
    if (area == "") {
        return [];
    }
    return fetchWrapper.get(`${baseUrl}/locker-inventory-transfer/` + date + `/` + area + '/' + reservationId);
}

function getLockerInventory(date, area) {
  if (area == "") {
    return [];
  }
  return fetchWrapper.get(`${baseUrl}/locker-inventory/`+date+`/`+area);
}

function getLockerAreaForReservation(reservationId) {
    return fetchWrapper.get(`${baseUrl}/locker-inventory-area/` + reservationId);
}

function getLockerPricing() {
    return fetchWrapper.get(`${baseUrl}/locker-pricing`);
}

function getAllForKiosk(venue) {
    return fetchWrapper.get(`${baseUrl}/getallforkiosk/` + venue);
}

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getUtilization(){
    return fetchWrapper.get(`${baseUrl}/utilization`);

}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function getVenues() {
    return getAll()
        .then(lockers => { 
    var v = []
    lockers.forEach(locker => {
        if (!v.includes(locker.venue)) {
            v.push(locker.venue);
        }
    });
    return v
});
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params)
        .then(locker => {
            return locker;
        });
}

// prefixed with underscore because 'delete' is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`)
        .then(x => {
            return x;
        });
}
